import { useEffect, useRef } from 'react';
import api from '../utils/api';

const INTERVALO_MS = 5 * 60 * 1000; // 5 minutos

export function useGeoTracking(activo) {
  const intervalRef = useRef(null);

  const enviarUbicacion = () => {
    if (!navigator.geolocation) return;
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        api.post('/ubicaciones', {
          lat:              pos.coords.latitude,
          lng:              pos.coords.longitude,
          precision_metros: Math.round(pos.coords.accuracy),
        }).catch(() => {}); // silencioso si falla
      },
      () => {}, // silencioso si deniega
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 60000 }
    );
  };

  useEffect(() => {
    if (!activo) {
      if (intervalRef.current) clearInterval(intervalRef.current);
      return;
    }

    // Enviar inmediatamente al activar
    enviarUbicacion();

    // Luego cada 5 minutos
    intervalRef.current = setInterval(enviarUbicacion, INTERVALO_MS);

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [activo]);
}
